import { NazioneDTO } from './nazione.dto';
import { TipologicaDTO } from './tipologica-d-t-o';

export class ModalitaPagamentoDTO {
	conto: string;
	denominazione: string;
	idModalitaPagamento: string;
	idPersona: string;
	idSede: string;
	indirizzo: string;
	nazione: NazioneDTO;
	numeroConto: string;
	preferito: boolean;
	swiftBic: string;
	tesoreria: TipologicaDTO;
	tipologiaPagamento: TipologicaDTO;
}

export function fromIdAndTipo(idModalitaPagamento: string, tipoModalitaPagamento: string) {
	const modalitaPagamento = new ModalitaPagamentoDTO();
	modalitaPagamento.idModalitaPagamento = idModalitaPagamento;
	modalitaPagamento.tipologiaPagamento = {
		codice : tipoModalitaPagamento,
		id: "",
		descrizione: "",
		codiceLingua: ""
	}
	return modalitaPagamento;
}